



























































































































import router from "@/router"
import {defineComponent, onUnmounted, reactive} from "@vue/composition-api"
import {Application, AppUpgradeInfo, EnvironmentStatus, getEnvironment, upgradeApp} from "@/data/repos/environments"
import Status from "@/components/Status.vue"
import BaseLayout from "@/components/layout/BaseLayout.vue"
import Loading from "@/components/Loading.vue"
import ModalContainer from "@/components/ModalContainer.vue"

export default defineComponent({
  components: {BaseLayout, Status, Loading, ModalContainer},
  props: {id: {required: false, type: String}},
  setup(p) {
    const state = reactive({
      environment: {} as EnvironmentStatus | undefined,
      error: false,
      displayAppUpgradeDialog: false,
      upgrade: {} as {upgradeInfo: AppUpgradeInfo; app: Application},
      isOps: true,
    })

    async function updateEnvStatus() {
      const envId = p.id || router.currentRoute.params.id
      state.environment = await getEnvironment(envId)
      state.error = !state.environment
    }

    updateEnvStatus()
    const updateTimer = setInterval(() => updateEnvStatus(), 60 * 1000)
    onUnmounted(() => clearInterval(updateTimer))

    const images = require.context("@/assets/images/", false, /\.svg$/)

    function getCopyImage() {
      return images("./copy.svg")
    }

    function copyToClipboard(text: string) {
      navigator.clipboard.writeText(text)
    }

    function confirmAppUpgrade(env: string, application: Application) {
      state.upgrade = {
        upgradeInfo: {env, app: application.id, versionTitle: application.baselineVersionTitle || "", version: application.upgradeToBaselineVersion || ""},
        app: application,
      }
      state.displayAppUpgradeDialog = true
    }

    function initiateAppUpgrade() {
      upgradeApp(state.upgrade.upgradeInfo)
      state.displayAppUpgradeDialog = false
      state.upgrade.app.upgradeInProgress = true
    }

    return {state, getCopyImage, copyToClipboard, initiateAppUpgrade, confirmAppUpgrade}
  },
})
